import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { LoaderTextAnimation } from '@types';

export const useGetTextForAnimation = (): LoaderTextAnimation[] => {
	// keep this hook here to update when translations obtained
	const resources = TranslationHelper.getByKey('placeholder.loader.animation.list');
	const loaderTextAnimation: LoaderTextAnimation[] = (resources?.result as LoaderTextAnimation[]) || [];

	return loaderTextAnimation;
};
